import { ObservableBoolean, observable } from '@legendapp/state';

import { VehicleTrimResponse } from '../../services/victor/trim-layer-details-response';
import { rootStore } from '../index';

interface EmissionStore {
	emissionData?: VehicleTrimResponse['trimLayer'];
	isEmissionDataVisible: ObservableBoolean;
}

export const emissionStore = observable<EmissionStore>({
	emissionData: undefined,
	isEmissionDataVisible: () => checkIfEmissionIsVisible
});

const checkIfEmissionIsVisible = () => {
	const emissionData = emissionStore.emissionData.get();
	const [currentModelKey] = rootStore.currentModel.get();

	if (!emissionData?.mustShowRanges) {
		return false;
	}

	if (emissionData) {
		return !!emissionData;
	}

	console.error(`EfficiencyData is not existing for ${currentModelKey}. Contact Dev team for better understanding`);
	return false;
};

export const emissionStoreActions = {
	setEmissionData: (emissionData?: VehicleTrimResponse['trimLayer']) => {
		emissionStore.emissionData.set(emissionData);
	}
};
